document.querySelectorAll('.circle-carousel-wrapper').forEach((wrapper) => {
  const track = wrapper.querySelector('.circle-carousel-track');
  const prevBtn = wrapper.querySelector('.circle-carousel-arrow--prev');
  const nextBtn = wrapper.querySelector('.circle-carousel-arrow--next');
  if (!track) return;

  const updateScrollState = () => {
    const isScrollable = track.scrollWidth > track.clientWidth + 1;
    track.classList.toggle('is-scrollable', isScrollable);
    wrapper.classList.toggle('has-arrows-visible', isScrollable);
  };

  updateScrollState();
  window.addEventListener('resize', updateScrollState);

  track.querySelectorAll('img').forEach((img) => {
    if (!img.complete) img.addEventListener('load', updateScrollState, { once: true });
  });

  const getScrollAmount = () => {
    const firstItem = track.querySelector('.circle-carousel-item');
    if (!firstItem) return track.clientWidth;
    const itemWidth = firstItem.getBoundingClientRect().width;
    const gap = parseFloat(getComputedStyle(track).gap) || 0;
    return (itemWidth + gap) * 2;
  };

  prevBtn?.addEventListener('click', () => {
    track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
  });

  nextBtn?.addEventListener('click', () => {
    track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
  });

  let isDown = false;
  let startX;
  let scrollLeft;

  track.addEventListener('mousedown', (e) => {
    isDown = true;
    track.classList.add('is-dragging');
    startX = e.pageX - track.offsetLeft;
    scrollLeft = track.scrollLeft;
  });

  ['mouseleave', 'mouseup'].forEach((evt) => {
    track.addEventListener(evt, () => { isDown = false; });
  });

  track.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - track.offsetLeft;
    const walk = (x - startX) * 1.2;
    track.scrollLeft = scrollLeft - walk;
  });
});